import { render, staticRenderFns } from "./QueryStoreVersion.vue?vue&type=template&id=6ea4807f&"
import script from "./QueryStoreVersion.vue?vue&type=script&lang=js&"
export * from "./QueryStoreVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports